import { render, staticRenderFns } from "./APopupImage.vue?vue&type=template&id=c17d4718&scoped=true"
import script from "./APopupImage.vue?vue&type=script&lang=js"
export * from "./APopupImage.vue?vue&type=script&lang=js"
import style0 from "./APopupImage.vue?vue&type=style&index=0&id=c17d4718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17d4718",
  null
  
)

export default component.exports